import react from 'react';
import AppModel from 'models/app';

class Location extends AppModel {
	constructor(type, store, props = {}) {
		super(type, store, props);

		// Attrs
		this.name = props.name;
		this.address = props.address;
		this.city = props.city;
		this.state = props.state;
		this.country = props.country;
		this.postalCode = props.postalCode;
		this.latitude = props.latitude;
		this.longitude = props.longitude;

		this.locationableId = props.locationableId;
		this.locationableType = props.locationableType;


		// BelongsTo
		this.booking = this.belongsTo('booking', props.booking);
		this.user = this.belongsTo('user', props.user);
		this.provider = this.belongsTo('provider', props.props);
	}


	// Computed
	get summary() {
		if (!this.address) return '';
		const statePostal = [this.state, this.postalCode].filter(Boolean).join(' ');
		return [this.address, this.city, statePostal].filter(Boolean).join(', ');
	}

	get cityState() {
		return [this.city, this.state].filter(Boolean).join(', ');
	}

	get cityStatePostal() {
		const statePostal = [this.state, this.postalCode].filter(Boolean).join(' ');
		return [this.city, statePostal].filter(Boolean).join(', ');
	}
}

export default Location;
